// @ts-nocheck
import "./ReviewsList.scss";

import { Component, h, render } from "preact";
import { Connect, Provider } from "redux-zero/preact";
import { getReviews, toggleDislike, toggleLike } from "@/api";
import { useCallback, useEffect, useState } from "preact/hooks";

import { Button } from "@components/Button/Button";
import { LIMITATION_TYPE_ENUM } from "@/api/constants";
import ReviewItem from "@/components/ReviewItem/ReviewItem";
import Select from "../Select/Select";
import { Theme } from "../Theme";
import actions from "@store/actions";
import { getCustomText } from "@/utils/getCustomText";
import store from "@store/store";
import { useLimitation } from "@/hooks/useLimitation";

const mapToProps = ({ reviews, user_likes, user_dislikes }) => ({
  reviews,
  user_likes,
  user_dislikes,
});

function ReviewsList({ productUid, hideTitle = false }) {
  return (
    <Theme widget="reviewsListWidget">
      <Provider store={store}>
        <Connect mapToProps={mapToProps} actions={actions}>
          {({
            reviews: allReviews,
            user_likes,
            user_dislikes,
            setReviews,
            toggleLikeAction,
            toggleDislikeAction,
          }) => {
            const reviewsData = allReviews[productUid];

            const [loading, setLoading] = useState(reviewsData === undefined);
            const [orderBy, setOrderBy] = useState("useful"); // 'useful' | 'date' | 'hight_grade' | 'low_grade'

            const isAllowedReviewsSorting = useLimitation(
              LIMITATION_TYPE_ENUM.reviewsSorting
            );
            const isAllowedReviewsPhotos = useLimitation(
              LIMITATION_TYPE_ENUM.reivewsPhoto
            );

            const loadMoreReviews = useCallback(
              async (page, orderBy) => {
                setLoading(true);

                const { reviews, user_likes, user_dislikes } = await getReviews(
                  productUid,
                  page,
                  orderBy
                );

                setReviews({
                  id: productUid,
                  reviews: reviews,
                  user_likes: user_likes,
                  user_dislikes: user_dislikes,
                });

                setLoading(false);
              },
              [reviewsData?.next_page_url, reviewsData?.current_page]
            );

            const handleLoadMore = useCallback(() => {
              loadMoreReviews(reviewsData.current_page + 1);
            });

            const handleToggleLike = useCallback((review_id) => {
              toggleLikeAction({ reviewId: review_id, productUid });
              toggleLike(review_id);
            });

            const handleToggleDislike = useCallback((review_id) => {
              toggleDislikeAction({ reviewId: review_id, productUid });
              toggleDislike(review_id);
            });

            const handleChangeOrderBy = useCallback(
              (newVal) => setOrderBy(newVal),
              [setOrderBy]
            );

            useEffect(() => {
              loadMoreReviews();
            }, []);

            useEffect(() => {
              loadMoreReviews(1, orderBy);
            }, [orderBy]);

            return (
              <div
                className="CCReviewsList"
                data-reviews-list-product-uid={productUid}
              >
                <div className="CCReviewsList__header">
                  {!hideTitle && (
                    <div className="CCReviewsList__title t-text">
                      {getCustomText("reviewsListTitle")}
                    </div>
                  )}

                  {isAllowedReviewsSorting ? (
                    <Select
                      value={orderBy}
                      onChange={handleChangeOrderBy}
                      disabled={loading}
                      options={[
                        {
                          label: getCustomText("reivewsSorting.date"),
                          value: "date",
                        },
                        isAllowedReviewsPhotos && {
                          label: getCustomText("reivewsSorting.withPohoto"),
                          value: "with_photo",
                        },
                        {
                          label: getCustomText("reivewsSorting.useful"),
                          value: "useful",
                        },
                        {
                          label: getCustomText("reivewsSorting.hightGrade"),
                          value: "hight_grade",
                        },
                        {
                          label: getCustomText("reivewsSorting.lowGrade"),
                          value: "low_grade",
                        },
                      ].filter(Boolean)}
                      style="min-width: 240px"
                    />
                  ) : null}
                </div>

                <div className="CCReviewsList__wrap">
                  {reviewsData ? (
                    reviewsData.data.length ? (
                      reviewsData.data.map((r) => (
                        <ReviewItem
                          {...r}
                          user_likes={user_likes}
                          user_dislikes={user_dislikes}
                          onToggleLike={handleToggleLike}
                          onToggleDislike={handleToggleDislike}
                        />
                      ))
                    ) : (
                      <p className="CCReviewsList__empty t-text">
                        {getCustomText("reviewsEmpty")}
                      </p>
                    )
                  ) : (
                    <p className="CCReviewsList__loading t-text">
                      {getCustomText("reviewsLoading")}
                    </p>
                  )}
                </div>

                {reviewsData?.next_page_url && (
                  <div className="CCReviewsList__load-more">
                    <Button onClick={handleLoadMore} disabled={loading}>
                      {loading
                        ? getCustomText("pagination.loading")
                        : getCustomText("pagination.showMore")}
                    </Button>
                  </div>
                )}
              </div>
            );
          }}
        </Connect>
      </Provider>
    </Theme>
  );
}

export default ReviewsList;
